module.exports = __webpack_public_path__ + "img/legal_documentation.84d82e6f.svg";